import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { type FilterOption } from '@/types/advanceFilter';
import { type TagFilterMode } from './tagKeyValueUtils';

/**
 * Turns the discovered tag list into the selectable options for one filter mode, shared by the tags
 * condition popover and the tags full panel so both offer the same options for the same search terms.
 */
export const useTagOptions = t0 => {
  const $ = _c(14);
  const {
    tags,
    selectedValues,
    keyFilter,
    valueFilter,
    mode
  } = t0;
  let merged;
  if ($[0] !== selectedValues || $[1] !== tags) {
    merged = [...(tags ?? [])];
    selectedValues.forEach(tag => {
      const [key, value] = tag.split("=");
      if (!merged.some(t => t.key === key && t.value === value)) {
        merged.push({
          key,
          value
        });
      }
    });
    $[0] = selectedValues;
    $[1] = tags;
    $[2] = merged;
  } else {
    merged = $[2];
  }
  const allTags = merged;
  let t1;
  if ($[3] !== allTags) {
    t1 = new Set(allTags.map(_temp));
    $[3] = allTags;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const distinctKeys = t1;
  let t2;
  if ($[5] !== distinctKeys || $[6] !== keyFilter) {
    t2 = Array.from(distinctKeys).filter(key_0 => !keyFilter || key_0.toLowerCase().includes(keyFilter.toLowerCase())).map(_temp2);
    $[5] = distinctKeys;
    $[6] = keyFilter;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const keys = t2;
  let t3;
  if ($[8] !== allTags || $[9] !== keyFilter || $[10] !== valueFilter) {
    const t4 = allTags.filter(t_0 => (!keyFilter || t_0.key.toLowerCase().includes(keyFilter.toLowerCase())) && (!valueFilter || !!t_0.value?.toLowerCase().includes(valueFilter.toLowerCase())));
    let t5;
    if ($[12] !== t4) {
      t5 = new Set(t4.map(_temp3));
      $[12] = t4;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    const allValues = Array.from(t5);
    t3 = allValues.map(_temp4);
    $[8] = allTags;
    $[9] = keyFilter;
    $[10] = valueFilter;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const keyValuePairs = t3;
  return mode === "key" ? keys : keyValuePairs;
};
function _temp(tag_0) {
  return tag_0.key;
}
function _temp2(key_1) {
  return {
    id: key_1,
    name: key_1
  };
}
function _temp3(x) {
  return `${x.key}=${x.value || ""}`;
}
function _temp4(value_0) {
  return {
    id: value_0,
    name: value_0
  };
}